// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var UsersSettingsController = function ($scope, User, UserResendConfirmation, gettextCatalog, gettext) {

    $scope.addUser = function () {
        $scope.newUser.$save({}, load);
    };

    $scope.deleteUser = function (id) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete User Account?')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () { $scope.newUser.$delete({ id: id }, load); });
    };

    function load() {
        $scope.users = User.query();
        $scope.newUser = new User();
    };

    $scope.resendConfirmation = function (id) {
        UserResendConfirmation.save( {userId:id}, {}, function() {
            $scope.notify("success", gettextCatalog.getString(gettext("Confirmation request mail resent successfully")));
        } );

    };

    $scope.editUser = null;

    $scope.cancelEditMode = function() {
        $scope.editUser = null;
    };

    $scope.activateEditMode = function (id) {
        if ($scope.editUser)
        //according IT-2238
            $scope.yesNoCancel(gettextCatalog.getString(gettext('Edit mode')), gettextCatalog.getString(gettext('Another row is in edit mode. Would you like to switch?')),
                function () {
                    $scope.cancelEditMode();
                    $scope.activateEditMode( id );
                },
                function (){}
            );
        else
            $scope.editUser = User.get({id:id});
    };
    $scope.saveUser = function() {
        $scope.editUser.$update( {},
            function() {
                $scope.cancelEditMode();
                $scope.notifySuccess();
                load();
            } );
    };

    load();

    $scope.userRoleCheckChange = function (isAdminRoleChanged) {
        if ( $scope.editUser ) {
            var r = $scope.editUser.Roles;
            if ( isAdminRoleChanged ) {
                r.IsInReportsRole = false;
                r.IsInFinanceRole = false;
                r.IsInOperationsRole = false;
                r.IsInProductsRole = false;
                r.IsInTemplatesRole = false;
            } else {
                r.IsInAdminRole = false;
            }
        }
    };
};
UsersSettingsController.$inject = ['$scope', 'User','UserResendConfirmation', 'gettextCatalog', 'gettext'];
